var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('RepoIssues',{attrs:{"repo":_vm.repo}})],1),_c('v-col',{staticClass:"ml-2",attrs:{"cols":"3"}},[_c('RepoContent',{attrs:{"repo":_vm.repo}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }